import { Text } from "@mantine/core";
import CancelRounded from "@mui/icons-material/CancelRounded";
import CheckCircleRounded from "@mui/icons-material/CheckCircleRounded";
import clsx from "clsx";
import type { AccountTypePreviewItem as AccountTypePreviewItemData } from "./accountTypePreviewData";
import classes from "./AccountTypePreviewItem.module.css";

export default function AccountTypePreviewItem({
  item,
  active,
}: {
  item: AccountTypePreviewItemData;
  active: boolean;
}) {
  const Icon = item.Icon;

  return (
    <div className={clsx(classes.item, active && classes.itemActive)}>
      <Icon
        className={clsx(classes.itemIcon, active && classes.itemIconActive)}
      />
      <div className={classes.copy}>
        <Text className={clsx(classes.title, active && classes.titleActive)}>
          {item.title}
        </Text>
        <Text
          className={clsx(
            classes.description,
            active && classes.descriptionActive
          )}
        >
          {item.description}
        </Text>
      </div>
      {active ? (
        <CheckCircleRounded
          className={clsx(classes.statusIcon, classes.statusIconActive)}
        />
      ) : (
        <CancelRounded className={classes.statusIcon} />
      )}
    </div>
  );
}
